/**
 * Get today's date in the client's local timezone formatted as YYYY-MM-DD
 * This respects the user's local timezone instead of UTC
 * @returns {string} Today's date in YYYY-MM-DD format
 */
export const getLocalTodayString = (): string => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};
